import { StateContext } from "@ngxs/store";
import { catchError, combineLatest, map, of, tap } from "rxjs";
import { isNil, mergeWith } from 'lodash';

import * as API from '@hiptraveler/data-access/api';
import { ItineraryStateModel } from "..";

interface Props {
  ctx: StateContext<ItineraryStateModel>;
  data: API.RequestByIdDto;
  imageApi: API.ImageApiService;
  bookApi: API.BookApiService;
}

export function loadAndMergeItineraryMediaStreams({ ctx, data, imageApi, bookApi }: Props) {
  
  const image$ = imageApi.getImageInformation(data).pipe(
    tap(response => API.validateResponse(response)),
    map(resp => resp.data?.content),
    catchError(() => of({}))
  );

  const yelp$ = imageApi.getYelpContent(data).pipe(
    tap(response => API.validateResponse(response)),
    map(resp => resp.data?.content),
    catchError(() => of({}))
  );

  const tripAdvisor$ = bookApi.getTripAdvisorData(data, 'image').pipe(
    tap(response => API.validateResponse(response)),
    map(resp => ({ taDataMap: resp.data?.error ? null : resp.data })),
    catchError(() => of({ taDataMap: null }))
  );

  const imageContent$ = combineLatest([ image$, yelp$, tripAdvisor$ ]).pipe(
    tap(([ imgContent, yelpContent, tripAdvisorContent ]) => {
      const result = combineObject<API.ImageResultData>(
        imgContent,
        yelpContent,
        tripAdvisorContent
      );

      ctx.patchState({
        imageInformation: result
      });
    })
  );

  return combineLatest([ imageContent$ ]);
}

function combineObject<T>(objectA: any, objectB: any, objectC: any): T {
  objectA = objectA || {};
  objectB = objectB || {};
  objectC = objectC || {};
  return mergeWith(
    {},
    objectA,
    objectB,
    objectC,
    (objValue: any, srcValue: any) => 
      isNil(objValue)
        ? srcValue
          : isNil(srcValue)
        ? objValue
          : objValue
  ) || {};
}
